import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('span',{attrs:{"id":"botao-carregamento-arquivos"}},[_c(VIcon,{attrs:{"left":"","dark":""}},[_vm._v("$TrayArrowUp")]),_c('span',[_vm._v("Carregar arquivos")])],1),_c(VFileInput,{staticClass:"d-none",attrs:{"multiple":""},model:{value:(_vm.arquivos_de_cotacao),callback:function ($$v) {_vm.arquivos_de_cotacao=$$v},expression:"arquivos_de_cotacao"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }